export default {"src":"/_next/static/media/question_mark.10e317c2.svg","height":27,"width":23,"blurWidth":0,"blurHeight":0};